import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index'
import Search from '@/views/search'
// 关于我们
import Overview from '@/views/us/overview'
import Contact from '@/views/us/contact'
import Law from '@/views/us/law'
import Job from '@/views/us/job'
import Webmap from '@/views/us/webmap'
import Friends from '@/views/us/friends'
// 资质证书
import Honor1 from '@/views/honor/honor1'
import Honor2 from '@/views/honor/honor2'
// 新闻中心
import Company from '@/views/news/company'
import Product from '@/views/news/product'
import Product1 from '@/views/news/product1'
import New1 from '@/views/news/new1'
// 经典案例
import Xuanhe from '@/views/classics/xuanhe'
import Xiaohan from '@/views/classics/xiaohan'
// 产品展示
import Gaoyabianping from '@/views/view/gaoyabianping'
import Diyabianping from '@/views/view/diyabianping'
import Ruanqidong from '@/views/view/ruanqidong'
import Plc from '@/views/view/plc'
import Gaodiyadianji from '@/views/view/gaodiyadianji'
import Gaodiyayuanjian from '@/views/view/gaodiyayuanjian'
import Kaiguangui from '@/views/view/kaiguangui'
import Jiqijicheng from '@/views/view/jiqijicheng'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', component: Index, name: '0-首页' },
    { path: '/honor1', component: Honor1, name: '4-电子与智能化二级' },
    { path: '/honor2', component: Honor2, name: '4-施工劳务序列' },
    { path: '/search', component: Search, name: '0-查询' }, // 关于我们
    { path: '/webmap', component: Webmap, name: '5-网站地图' },
    { path: '/law', component: Law, name: '5-法律声明' },
    { path: '/friends', component: Friends, name: '5-合作伙伴' },
    { path: '/job', component: Job, name: '5-招贤纳士' },
    { path: '/overview', component: Overview, name: '5-公司概况' },
    { path: '/contact', component: Contact, name: '5-联系我们' }, // 新闻中心
    { path: '/company', component: Company, name: '3-公司新闻' },
    { path: '/product', component: Product, name: '3-行业动态' },
    { path: '/product1', component: Product1, name: '3-行业动态1' },
    { path: '/new1', component: New1, name: '3-公司新闻1' }, // 经典案例
    { path: '/xuanhe', component: Xuanhe, name: '2-宣鹤太平隧道' },
    { path: '/xiaohan', component: Xiaohan, name: '2-孝汉应高速公路' }, // 产品展示
    { path: '/gaoyabianping', component: Gaoyabianping, name: '1-高压变频器系列' },
    { path: '/diyabianping', component: Diyabianping, name: '1-低压变频器系列' },
    { path: '/ruanqidong', component: Ruanqidong, name: '1-软启动器' },
    { path: '/plc', component: Plc, name: '1-PLC伺服控制系统' },
    { path: '/gaodiyadianji', component: Gaodiyadianji, name: '1-高低压电机' },
    { path: '/gaodiyayuanjian', component: Gaodiyayuanjian, name: '1-高低压电器元件' },
    { path: '/kaiguangui', component: Kaiguangui, name: '1-开关柜' },
    { path: '/jiqijicheng', component: Jiqijicheng, name: '1-工业机器人集成' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js